<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="container-fluid mt--6">
      <b-row class="justify-content-center">
        <b-col lg="8" class="card-wrapper ct-example">
          <!-- Styles -->
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Grievance Details</h3>
            </b-card-header>
            <b-card-body>
              <form>
                <b-row class="form-group">
                   <b-col md="6" class="mb-3">
              Submitted on :
              <h2 class="mb-0">{{ createdDate }}</h2>
              Submitted by :
              <h2 class="mb-0">{{ inputs.created_by }}</h2>
            </b-col>
            <b-col md="6" v-if="inputs.isAcknowledged">
              Acknowledged on :
              <h2 class="mb-0">{{ acknowledgeDate }}</h2>
              Acknowledged by :
              <h2 class="mb-0">{{ inputs.acknowledged_by }}</h2>
            </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="6">
                    Severity : 
                    <h2 class="mb-0">
                      <b>{{ inputs.severity | UPPERCASE }}</b>
                    </h2>
                  </b-col>
                  <b-col md="6">
                    Targetted Regions : 
                    <h4
                      v-for="region in inputs.target_region"
                      :key="region"
                      class="mb-0 d-flex"
                    >
                      {{ region | UPPERCASE }}
                    </h4>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="12">
                    Subject : <h2 class="mb-0">{{ inputs.subject }}</h2>
                  </b-col>
                  <b-col md="12">
                    Details : <h2 class="mb-0">{{ inputs.message }}</h2>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="12">
                    <base-input label="Acknowledgement Comment">
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="2"
                        v-model="inputs.comments"
                      ></textarea>
                    </base-input>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="12" class="text-right">
                    <router-link
                      :to="{
                        name: 'Grievances'
                      }"
                    >
                      <base-button type="primary"
                        >Back to Grievances</base-button
                      >
                    </router-link>
                    <base-button
                      v-if="!inputs.isAcknowledged"
                      icon
                      type="success"
                      @click="onUploadClick"
                    >
                      <span class="btn-inner--icon"
                        ><i class="ni ni-bag-17"></i
                      ></span>
                      <span class="btn-inner--text">Acknowledge</span>
                    </base-button>

                    <!-- <base-button
                      v-else
                      icon
                      type="success"
                      @click="onUploadClick"
                    >
                      <span class="btn-inner--icon"
                        ><i class="ni ni-bag-17"></i
                      ></span>
                      <span class="btn-inner--text">Acknowledge</span>
                    </base-button> -->
                  </b-col>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
          <!-- Colors -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import moment from "moment";
import { API } from "../../services/api.service";

export default {
  data: function() {
    return {
      inputs: {
        subject: "",
        message: "",
        severity: "",
        target_region: []
      },
      progress: 0,
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true
      },
      errors: [],
      miscellaneous: [],
      selectedRows: [],
      src: undefined,
      numPages: undefined
    };
  },
  created() {
    try {
      API.GET_GRIEVANCE(this.$route.params.id)
        .then(async res => {
          console.log(res);
          if (res.data.ok) {
            this.inputs = res.data.result;
            !this.inputs.comments ? (this.inputs.comments = "") : true;
          }
        })
        .catch(e => {});
    } catch (e) {
      console.log(e);
    }
  },
  filters: {
    UPPERCASE(str) {
      var newStr = "";
      if (str)
        for (var i = 0; i < str.length; i++) {
          var thisCharCode = str[i].charCodeAt(0);
          if (
            (thisCharCode >= 97 && thisCharCode <= 122) ||
            (thisCharCode >= 224 && thisCharCode <= 255)
          ) {
            newStr += String.fromCharCode(thisCharCode - 32);
          } else {
            newStr += str[i];
          }
        }
      return newStr;
    }
  },
  computed: {
    ...mapGetters("user", ["getToken"]),
    createdDate: {
      get() {
        return this.inputs.created_date
          ? moment(this.inputs.created_date).format("DD MMM YYYY")
          : "";
      }
      // setter
      //   set(newValue) {
      //     this.inputs.created_date = new Date(newValue);
      //   }
    },
    acknowledgeDate: {
      get() {
        return this.inputs.acknowledged_on
          ? moment(this.inputs.acknowledged_on).format("DD MMM YYYY")
          : "";
      },
    },
  },
  mixins: [clientPaginationMixin],
  components: {
    BaseHeader,
    RouteBreadcrumb
  },
  methods: {
    myToUpperCase(str) {
      var newStr = "";
      for (var i = 0; i < str.length; i++) {
        var thisCharCode = str[i].charCodeAt(0);
        if (
          (thisCharCode >= 97 && thisCharCode <= 122) ||
          (thisCharCode >= 224 && thisCharCode <= 255)
        ) {
          newStr += String.fromCharCode(thisCharCode - 32);
        } else {
          newStr += str[i];
        }
      }
      return newStr;
    },
    validate() {
      this.errors = [];
      //   if (!this.inputs.title) this.errors.push("Title Required!");
      if (!this.inputs.comments)
        this.errors.push("Acknowledgement message Required!");
    },

    onUploadClick() {
      //   this.validate();
      try {
        if (!this.errors.length) {
          let dataObj = {
            comments: this.inputs.comments
          };

          API.ACK_GRIEVANCE(this.$route.params.id, dataObj)
            .then(async res => {
              swal.fire({
                title: `Grievance Acknowledged Successfully!`,
                buttonsStyling: false,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill"
              });
            })
            .catch(e => {});
        }
      } catch (e) {
        swal.fire({
          title: `${e}`,
          buttonsStyling: false,
          type: "error",
          confirmButtonClass: "btn btn-danger btn-fill"
        });
      }
    },
    progressUpdate(progressEvent) {
      this.progress = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },
    filesChange(files) {
      let formData = new FormData();
      formData.append("file", this.inputs.file);

      API.UPLOAD_FILE(this.progressUpdate, formData)
        .then(res => {
          this.inputs.file_id = res.data.result.fileId;
        })
        .catch(err => {
          swal.fire({
            title: `${err}`,
            buttonsStyling: false,
            type: "error",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    uploadFile() {},
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },
    handleLike(index, row) {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
